import moment from 'moment';
import { ModelBase } from '../abstract/model-base.model';
import { Account } from './account.model';
import { AccountingMethod } from './accounting-method.model';
import { TaxationRegime } from '../taxation/taxation-regime.model';
import { TaxationType } from '../taxation/taxation-type.model';
import { VatChargeability } from '../taxation/vat-chareability.model';
import { VatFrequency } from '../taxation/vat-frequency.model';

export class AccountingSettings extends ModelBase {

    static override CLASS_NAME: string = 'AccountingSettings';

    private _accountingMethod!: AccountingMethod;
    private _accountNumberLength!: number;
    private _enableAuxiliaryAccountsDetection!: boolean;
    private _enableCreditorDebtorAccounts!: boolean;
    private _vendorAccount!: Account;
    private _vendorDebtorAccount!: Account;
    private _vendorDownpaymentAccount!: Account;
    private _clientAccount!: Account;
    private _clientCreditorAccount!: Account;
    private _clientDownpaymentAccount!: Account;
    private _employeeAccount!: Account;
    private _subsidyReceivableAccount!: Account;
    private _expensesAccount!: Account;
    private _chargeAccount!: Account;
    private _lossAccount!: Account;
    private _productAccount!: Account;
    private _subsidyIncomeAccount!: Account;
    private _profitAccount!: Account;
    private _collectedTaxAccount!: Account;
    private _deductibleTaxAccount!: Account;
    private _taxPaymentAccount!: Account;
    private _taxReimbursementAccount!: Account;
    private _socialContributionAccount!: Account;
    private _socialOrganismAccount!: Account;
    private _salaryGrossAccount!: Account;
    private _managerRemunerationAccount!: Account;
    private _managerSocialContributionAccount!: Account;
    private _taxesAccount!: Account;
    private _cardRemittanceAccount!: Account;
    private _cashAccount!: Account;
    private _chequeWalletAccount!: Account;
    private _chequeDepositAccount!: Account;
    private _interestReceivedAccount!: Account;
    private _internalTransferAccount!: Account;
    private _exchangeRateGainAccount!: Account;
    private _exchangeRateLossAccount!: Account;
    private _taxationRegime!: TaxationRegime;
    private _taxationType!: TaxationType;
    private _vatChargeability!: VatChargeability;
    private _vatDateFrom!: moment.Moment;
    private _vatFrequency!: VatFrequency;
    private _vatSubject!: boolean;

    public get accountingMethod(): AccountingMethod {
        return this._accountingMethod;
    }

    public set accountingMethod(value: any) {
        this._setValue('_accountingMethod', value, 'AccountingMethod');
    }

    public get accountNumberLength(): number {
        return this._accountNumberLength;
    }

    public set accountNumberLength(value: any) {
        this._setValue('_accountNumberLength', value, 'integer');
    }

    public get enableAuxiliaryAccountsDetection(): boolean {
        return this._enableAuxiliaryAccountsDetection;
    }

    public set enableAuxiliaryAccountsDetection(value: any) {
        this._setValue('_enableAuxiliaryAccountsDetection', value, 'boolean');
    }

    public get enableCreditorDebtorAccounts(): boolean {
        return this._enableCreditorDebtorAccounts;
    }

    public set enableCreditorDebtorAccounts(value: any) {
        this._setValue('_enableCreditorDebtorAccounts', value, 'boolean');
    }

    public get vendorAccount(): Account {
        return this._vendorAccount;
    }

    public set vendorAccount(value: any) {
        this._setValue('_vendorAccount', value, 'Account');
    }

    public get vendorDebtorAccount(): Account {
        return this._vendorDebtorAccount;
    }

    public set vendorDebtorAccount(value: any) {
        this._setValue('_vendorDebtorAccount', value, 'Account');
    }

    public get vendorDownpaymentAccount(): Account {
        return this._vendorDownpaymentAccount;
    }

    public set vendorDownpaymentAccount(value: any) {
        this._setValue('_vendorDownpaymentAccount', value, 'Account');
    }

    public get clientAccount(): Account {
        return this._clientAccount;
    }

    public set clientAccount(value: any) {
        this._setValue('_clientAccount', value, 'Account');
    }

    public get clientCreditorAccount(): Account {
        return this._clientCreditorAccount;
    }

    public set clientCreditorAccount(value: any) {
        this._setValue('_clientCreditorAccount', value, 'Account');
    }

    public get clientDownpaymentAccount(): Account {
        return this._clientDownpaymentAccount;
    }

    public set clientDownpaymentAccount(value: any) {
        this._setValue('_clientDownpaymentAccount', value, 'Account');
    }

    public get cardRemittanceAccount(): Account {
        return this._cardRemittanceAccount;
    }

    public set cardRemittanceAccount(value: any) {
        this._setValue('_cardRemittanceAccount', value, 'Account');
    }

    public get employeeAccount(): Account {
        return this._employeeAccount;
    }

    public set employeeAccount(value: any) {
        this._setValue('_employeeAccount', value, 'Account');
    }

    public get subsidyReceivableAccount(): Account {
        return this._subsidyReceivableAccount;
    }

    public set subsidyReceivableAccount(value: any) {
        this._setValue('_subsidyReceivableAccount', value, 'Account');
    }

    public get chargeAccount(): Account {
        return this._chargeAccount;
    }

    public set chargeAccount(value: any) {
        this._setValue('_chargeAccount', value, 'Account');
    }

    public get lossAccount(): Account {
        return this._lossAccount;
    }

    public set lossAccount(value: any) {
        this._setValue('_lossAccount', value, 'Account');
    }

    public get productAccount(): Account {
        return this._productAccount;
    }

    public set productAccount(value: any) {
        this._setValue('_productAccount', value, 'Account');
    }

    public get subsidyIncomeAccount(): Account {
        return this._subsidyIncomeAccount;
    }

    public set subsidyIncomeAccount(value: any) {
        this._setValue('_subsidyIncomeAccount', value, 'Account');
    }

    public get profitAccount(): Account {
        return this._profitAccount;
    }

    public set profitAccount(value: any) {
        this._setValue('_profitAccount', value, 'Account');
    }

    public get collectedTaxAccount(): Account {
        return this._collectedTaxAccount;
    }

    public set collectedTaxAccount(value: any) {
        this._setValue('_collectedTaxAccount', value, 'Account');
    }

    public get deductibleTaxAccount(): Account {
        return this._deductibleTaxAccount;
    }

    public set deductibleTaxAccount(value: any) {
        this._setValue('_deductibleTaxAccount', value, 'Account');
    }

    public get taxPaymentAccount(): Account {
        return this._taxPaymentAccount;
    }

    public set taxPaymentAccount(value: any) {
        this._setValue('_taxPaymentAccount', value, 'Account');
    }

    public get taxReimbursementAccount(): Account {
        return this._taxReimbursementAccount;
    }

    public set taxReimbursementAccount(value: any) {
        this._setValue('_taxReimbursementAccount', value, 'Account');
    }


    public get cashAccount(): Account {
        return this._cashAccount;
    }

    public set cashAccount(value: any) {
        this._setValue('_cashAccount', value, 'Account');
    }

    public get chequeWalletAccount(): Account {
        return this._chequeWalletAccount;
    }

    public set chequeWalletAccount(value: any) {
        this._setValue('_chequeWalletAccount', value, 'Account');
    }

    public get chequeDepositAccount(): Account {
        return this._chequeDepositAccount;
    }

    public set chequeDepositAccount(value: any) {
        this._setValue('_chequeDepositAccount', value, 'Account');
    }

    public get interestReceivedAccount(): Account {
        return this._interestReceivedAccount;
    }

    public set interestReceivedAccount(value: any) {
        this._setValue('_interestReceivedAccount', value, 'Account');
    }

    public get internalTransferAccount(): Account {
        return this._internalTransferAccount;
    }

    public set internalTransferAccount(value: any) {
        this._setValue('_internalTransferAccount', value, 'Account');
    }

    public get exchangeRateGainAccount(): Account {
        return this._exchangeRateGainAccount;
    }

    public set exchangeRateGainAccount(value: any) {
        this._setValue('_exchangeRateGainAccount', value, 'Account');
    }

    public get exchangeRateLossAccount(): Account {
        return this._exchangeRateLossAccount;
    }

    public set exchangeRateLossAccount(value: any) {
        this._setValue('_exchangeRateLossAccount', value, 'Account');
    }

    public get taxationRegime(): TaxationRegime {
        return this._taxationRegime;
    }

    public set taxationRegime(value: any) {
        this._setValue('_taxationRegime', value, 'TaxationRegime');
    }

    public get taxationType(): TaxationType {
        return this._taxationType;
    }

    public set taxationType(value: any) {
        this._setValue('_taxationType', value, 'TaxationType');
    }

    public get vatChargeability(): VatChargeability {
        return this._vatChargeability;
    }

    public set vatChargeability(value: any) {
        this._setValue('_vatChargeability', value, 'VatChargeability');
    }

    public get vatDateFrom(): moment.Moment {
        return this._vatDateFrom;
    }

    public set vatDateFrom(value: any) {
        this._setValue('_vatDateFrom', value, 'date');
    }

    public get vatFrequency(): VatFrequency {
        return this._vatFrequency;
    }

    public set vatFrequency(value: any) {
        this._setValue('_vatFrequency', value, 'VatFrequency');
    }

    public get vatSubject(): boolean {
        return this._vatSubject;
    }

    public set vatSubject(value: any) {
        this._setValue('_vatSubject', value, 'boolean');
    }

    public get expensesAccount(): Account {
        return this._expensesAccount;
    }

    public set expensesAccount(value: any) {
        this._setValue('_expensesAccount', value, 'Account');
    }

    public get socialContributionAccount(): Account {
        return this._socialContributionAccount;
    }

    public set socialContributionAccount(value: any) {
        this._setValue('_socialContributionAccount', value, 'Account');
    }

    public get socialOrganismAccount(): Account {
        return this._socialOrganismAccount;
    }

    public set socialOrganismAccount(value: any) {
        this._setValue('_socialOrganismAccount', value, 'Account');
    }

    public get salaryGrossAccount(): Account {
        return this._salaryGrossAccount;
    }

    public set salaryGrossAccount(value: any) {
        this._setValue('_salaryGrossAccount', value, 'Account');
    }

    public get managerRemunerationAccount(): Account {
        return this._managerRemunerationAccount;
    }

    public set managerRemunerationAccount(value: any) {
        this._setValue('_managerRemunerationAccount', value, 'Account');
    }

    public get managerSocialContributionAccount(): Account {
        return this._managerSocialContributionAccount;
    }

    public set managerSocialContributionAccount(value: any) {
        this._setValue('_managerSocialContributionAccount', value, 'Account');
    }

    public get taxesAccount(): Account {
        return this._taxesAccount;
    }

    public set taxesAccount(value: any) {
        this._setValue('_taxesAccount', value, 'Account');
    }

}
